import { connect } from 'react-redux';

import {
  removeFunnelStep,
  setFunnelStepClosingRange,
  setFunnelStepCount,
  setFunnelStepEventName,
  setFunnelStepOptionalStatus,
  toggleFunnelEnabled,
} from '../../../actions/funnel';
import { getEventNames, getUpdatingFunnel } from '../../../reducers/analyticsApp';
import FunnelUpdateStep from '../../../components/funnel/update/Step';

// TODO: pass only step id and retrieve all required info here?
const mapStateToProps = (state, { stepIndex, firstEnabledStepIndex }) => {
  const { steps } = getUpdatingFunnel(state);
  const stepsWithoutCurrent = [...steps.slice(0, stepIndex), ...steps.slice(stepIndex + 1)];
  const isOnlyEnabledStep = stepsWithoutCurrent.every((step) => !step.enabled);

  return {
    events: getEventNames(state),
    first: !stepIndex || stepIndex === firstEnabledStepIndex,
    perStepClosingRangeEnabled: true,
    isOnlyEnabledStep,
  };
};

const mapDispatchToProps = (dispatch, { stepIndex }) => ({
  setEventName: (event) => dispatch(setFunnelStepEventName(stepIndex, event)),
  setClosingRange: (closingRange) => dispatch(setFunnelStepClosingRange(stepIndex, closingRange)),
  removeStep: () => dispatch(removeFunnelStep(stepIndex)),
  toggleEnabled: () => dispatch(toggleFunnelEnabled(stepIndex)),
  setOptionalStatus: (status) => dispatch(setFunnelStepOptionalStatus(stepIndex, status)),
  setStepCount: (count, operator) => dispatch(setFunnelStepCount(stepIndex, count, operator)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FunnelUpdateStep);
